import {getPMSClient} from '../..'
import {getPMSBaseUrl} from '../../services/apiService'
import {createFetchActions} from '../../services/createActions'
import {SET_TRADE_BY} from '../dashboard/dashboardActions'
import {tradingQueueSummaryQuery} from '../dashboard/dashboardQueries'
import {dashboardEntityAmountQuery, dashboardPortfolioAnalyticsQuery} from './sblQueries'
import {get} from '../../services/createAPICall'
import {getUserGroupId} from '../../services/authService'

export const SET_SBL_CLICKED_PORTFOLIO_ENTITY = 'SET_SBL_CLICKED_PORTFOLIO_ENTITY'
export const SET_SBL_CLICKED_GROUPBY_ENTITY = 'SET_SBL_CLICKED_GROUPBY_ENTITY'
export const SET_CLICKED_FIRST_LEVEL_TREEMAP_VALUE = 'SET_CLICKED_FIRST_LEVEL_TREEMAP_VALUE'
export const SET_CLICKED_SECOND_LEVEL_TREEMAP_VALUE = 'SET_CLICKED_SECOND_LEVEL_TREEMAP_VALUE'
export const GET_CLICKED_PORTFOLIO_ENTITY = createFetchActions('GET_CLICKED_PORTFOLIO_ENTITY')
export const GET_CLICKED_GROUPBY_ENTITY = createFetchActions('GET_CLICKED_GROUPBY_ENTITY')
export const RESET_DASHBOARD_DATA = 'RESET_DASHBOARD_DATA'
export const GET_SBL_ENTITIES_AMOUNT = createFetchActions('GET_SBL_ENTITIES_AMOUNT')
export const GET_SBL_PORTFOLIO_ANALYTICS = createFetchActions('GET_DASHBOARD_PORTFOLIO_ANALYTICS')
export const GET_PORTFOLIO_UPLOADED_DATE = createFetchActions('GET_PORTFOLIO_UPLOADED_DATE')
export const GET_PORTFOLIO_DOCS_INCLUDED = createFetchActions('GET_PORTFOLIO_DOCS_INCLUDED')
export const SET_SBL_TOGGLE_INDEX = createFetchActions('SET_SBL_TOGGLE_INDEX')
export const SET_SBL_DRILLDOWNN = createFetchActions('SET_SBL_DRILLDOWNN')
export const GET_EXTERNAL_AVAILABILITIES = createFetchActions('GET_EXTERNAL_AVAILABILITIES')
export const GET_SBL_DASHBOARD_OVERVIEW_AND_RERATE = createFetchActions('GET_SBL_DASHBOARD_OVERVIEW_AND_RERATE')
export const GET_SBL_DASHBOARD_DUMMY = createFetchActions('GET_SBL_DASHBOARD_DUMMY')

export const setClickedPortfolioEntity = data => {
	return {
		type: SET_SBL_CLICKED_PORTFOLIO_ENTITY,
		response: {
			data: data,
		},
	}
}

export const setClickedFirstLevelTreemapValue = data => {
	return {
		type: SET_CLICKED_FIRST_LEVEL_TREEMAP_VALUE,
		response: {
			data: data,
		},
	}
}

export const setClickedSecondLevelTreemapValue = data => {
	return {
		type: SET_CLICKED_SECOND_LEVEL_TREEMAP_VALUE,
		response: {
			data: data,
		},
	}
}

export const setClickedGroupByEntity = (name, groupOne, groupTwo) => {
	return {
		type: SET_SBL_CLICKED_GROUPBY_ENTITY,
		response: {
			groupEntityname: name,
			groupOne,
			groupTwo,
		},
	}
}

export const setToggleActiveIndex = (name: string, index: number) => {
	return {
		type: SET_SBL_TOGGLE_INDEX,
		response: {
			toggleName: name,
			index,
		},
	}
}

export const setDrilldown = (name?: string, drilldownData?: Object) => {
	return {
		type: SET_SBL_DRILLDOWNN,
		response: {
			drilldownName: name,
			drilldownData,
		},
	}
}

const executePortfolioQuery = portfolioQuery => {
	if (!portfolioQuery) return null
	return getPMSClient()
		.query({
			query: portfolioQuery,
			fetchPolicy: 'network-only',
		})
		.then(response => {
			return response.data
		})
		.catch(error => {
			return null
		})
}

export const setTradeByData = (queryDetail: any[]) => {
	const firstQuery = queryDetail[0] && tradingQueueSummaryQuery(queryDetail[0].cptyName, queryDetail[0].cptyType)
	const secondQuery = queryDetail[1] && tradingQueueSummaryQuery(queryDetail[1].cptyName, queryDetail[1].cptyType)
	return function (dispatch) {
		dispatch({
			type: SET_TRADE_BY.triggered,
		})

		Promise.all([executePortfolioQuery(firstQuery), executePortfolioQuery(secondQuery)]).then(combinedResponse =>
			dispatch({
				type: SET_TRADE_BY.succeeded,
				response: {
					[queryDetail[0].tradeBy]: combinedResponse[0],
					[queryDetail[1].tradeBy]: combinedResponse[1],
				},
			})
		)
	}
}

export function getDashboardEntitiesAmount() {
	return function (dispatch) {
		dispatch({
			type: GET_SBL_ENTITIES_AMOUNT.triggered,
		})

		getPMSClient()
			.query({
				query: dashboardEntityAmountQuery,
				fetchPolicy: 'network-only',
			})
			.then(response => {
				dispatch({
					type: GET_SBL_ENTITIES_AMOUNT.succeeded,
					response,
				})
			})
	}
}

const executeFirstPortfolioQuery = firstPortfolioQuery => {
	if (!firstPortfolioQuery) return null
	return getPMSClient()
		.query({
			query: firstPortfolioQuery,
			fetchPolicy: 'network-only',
		})
		.then(response => {
			return response.data
		})
		.catch(error => {
			return null
		})
}

const executeSecondPortfolioQuery = secondPortfolioQuery => {
	if (!secondPortfolioQuery) return null
	return getPMSClient()
		.query({
			query: secondPortfolioQuery,
			fetchPolicy: 'network-only',
		})
		.then(response => {
			return response.data
		})
		.catch(error => {
			return null
		})
}

export const getDashboardPortfolioAnalytics = portfolioQueryType => {
	return function (dispatch) {
		dispatch({
			type: GET_SBL_PORTFOLIO_ANALYTICS.triggered,
		})

		const firstPortfolioQuery =
			Array.isArray(portfolioQueryType) &&
			portfolioQueryType.length > 0 &&
			dashboardPortfolioAnalyticsQuery[portfolioQueryType[0]]
		const secondPortfolioQuery =
			Array.isArray(portfolioQueryType) &&
			portfolioQueryType.length === 2 &&
			dashboardPortfolioAnalyticsQuery[portfolioQueryType[1]]

		Promise.all([
			executeFirstPortfolioQuery(firstPortfolioQuery),
			executeSecondPortfolioQuery(secondPortfolioQuery),
		]).then(combinedResponse =>
			dispatch({
				type: GET_SBL_PORTFOLIO_ANALYTICS.succeeded,
				response: [{[portfolioQueryType[0]]: combinedResponse[0]}, {[portfolioQueryType[1]]: combinedResponse[1]}],
			})
		)
	}
}

export const getExternalAvailabilitiesData = () => {
	const query = dashboardPortfolioAnalyticsQuery.externalAvailabilityQuery
	return function (dispatch) {
		dispatch({
			type: GET_EXTERNAL_AVAILABILITIES.triggered,
		})
		getPMSClient()
			.query({
				query,
				fetchPolicy: 'network-only',
			})
			.then(response => {
				dispatch({
					type: GET_EXTERNAL_AVAILABILITIES.succeeded,
					response,
				})
			})
	}
}

export const resetDashboardData = () => {
	return {
		type: RESET_DASHBOARD_DATA,
	}
}

export const getSblDashboardOverview = (dispatch: any) => {
	return dispatch(
		get(GET_SBL_DASHBOARD_DUMMY, `${getPMSBaseUrl()}/v1/sbl-dashboard/sblDashboardOverview?groupId=${getUserGroupId()}`)
	)
}

export const getSblDashboardReRateOverview = (dispatch: any) => {
	return dispatch(
		get(
			GET_SBL_DASHBOARD_DUMMY,
			`${getPMSBaseUrl()}/v1/sbl-dashboard/sblDashboardReRatesOverview?groupId=${getUserGroupId()}`
		)
	)
}

export const getSblOverviewWrapper = () => (dispatch: any) => {
	dispatch({
		type: GET_SBL_DASHBOARD_OVERVIEW_AND_RERATE.triggered,
	})

	getSblDashboardOverview(dispatch).then(res => {
		getSblDashboardReRateOverview(dispatch).then(innerRes => {
			dispatch({
				type: GET_SBL_DASHBOARD_OVERVIEW_AND_RERATE.succeeded,
				response: {
					data: {
						...res.response.data,
						...innerRes.response.data,
					},
				},
			})
		})
	})
}
